import { render, staticRenderFns } from "./_list.vue?vue&type=template&id=7f88b4e2&scoped=true"
import script from "./_list.vue?vue&type=script&lang=js"
export * from "./_list.vue?vue&type=script&lang=js"
import style0 from "./_list.vue?vue&type=style&index=0&id=7f88b4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f88b4e2",
  null
  
)

export default component.exports